import { render, staticRenderFns } from "./CertificadosTodos.vue?vue&type=template&id=14babd3a"
import script from "./CertificadosTodos.vue?vue&type=script&lang=js"
export * from "./CertificadosTodos.vue?vue&type=script&lang=js"
import style0 from "./CertificadosTodos.vue?vue&type=style&index=0&id=14babd3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports